<div>
	<cdk-table-component
		[displayColumns]="displayColumns"
		[entities]="tableEntities"
		[dataSource]="dataSource"
		[footer]="footer"
	></cdk-table-component>
</div>
